import { Component, Input, ChangeDetectionStrategy, OnDestroy } from '@angular/core';

@Component({
  selector: 'tp-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {
  @Input() name: string;
  @Input() isResponsive = false;

  public iconsPath = '/assets/';
}
